import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/blur.png")